import { createContext, useContext } from 'react'
import { FeatureFlags } from './types'

export type FeatureFlagsContextValue = { featureFlags: FeatureFlags; isFeatureFlagsLoading: boolean; isFeatureFlagsError: boolean }

const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  isProductFilesEnabled: false,
  isCustomerReferralEnabled: false,
  isOfflineDisplayEnabled: false,
  isOStromEnabled: false,
  isTibberEnabled: false,
  isLuoxDynamicEnergyTariffEnabled: false,
  isObservabilityAnalyticsEnabled: false,
  isAppRatingEnabled: false,
  isCustomerReferralAdministrationEnabled: false,
  isShowNewVehicleVendorsEnabled: false,
  isShopMaintenanceModeEnabled: false,
  isMaintenancePageEnabled: false,
  isReonicEnabled: false,
  isNewEmobiltyRouteEnabled: false,
  apiAccessGroups: undefined,
  chartSelector: {
    performance: false,
    poc: false,
    both: false,
  },
  isEnforcingIosAppUpdate: false,
  isChristmasThemeEnabled: false,
  isEasterThemeEnabled: false,
  shouldSimulateMobileAppOnWebview: false,
  isCreateInstallationEnabled: false,
  cloudPortalSmartFunctionShiftModeProductEnabled: {},
  isSgReadyEnabled: false,
  isAi360TariffBannerEnabled: false,
  isAi360FixedTariffEnabled: false,
  isAi360SharedTariffEnabled: false,
  /* Flow flags */
  showDetailedDeviceErrorMessages: false,
  useEvseWittyLinkSubTypes: false,
  maxWittyLinksPerInstallation: 0,
  useEvseWittyFlex: false,
  dynamicEmsMinimalVersion: 'none',
  minimumRequiredAppVersionForFlow: {
    iOS: '0.0.0',
    android: '0.0.0',
  },
  showGuidedTour: false,
  farmConfigurationEnabledForFlow: false,
  batterySettingsEnabled: false,
  isUserProfileApiClientEnabled: false,
  isExtensionsPageVisibleInFlow: false,
  isManualTariffEnabled: false,
  isTariffSettingBoxesEnabled: false,
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({
  featureFlags: DEFAULT_FEATURE_FLAGS,
  isFeatureFlagsLoading: true,
  isFeatureFlagsError: false,
})

export default FeatureFlagsContext

export const useFeatureFlagsContext = (): FeatureFlagsContextValue => useContext(FeatureFlagsContext)
